'use client';

import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onClose", "className", "withPortal", "center"];
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.mjs";
import { addColorSet } from "../../styles/index.mjs";
import { OverlayBackdrop, staticSet } from "./OverlayBackdrop.mjs";
import { useMergeRef } from "../../hooks/useMergeRef.mjs";
import { isWindowDefined } from "../../utils.mjs";
export var Backdrop = /*#__PURE__*/React.forwardRef(function Backdrop(_ref, ref) {
  var _ref$onClose = _ref.onClose,
    onClose = _ref$onClose === void 0 ? function () {} : _ref$onClose,
    className = _ref.className,
    withPortal = _ref.withPortal,
    center = _ref.center,
    props = _objectWithoutProperties(_ref, _excluded);
  var backdropRef = useMergeRef(ref);

  /* if backdrop is clicked, execute onClose */
  var onClick = function onClick(event) {
    if (event.target === backdropRef.current) {
      onClose(event);
    }
  };

  /* if escape key is pressed, execute onClose */
  var onKeydown = function onKeydown(event) {
    if (event.keyCode === 27 || event.code === 'Escape') {
      onClose(event);
    }
  };
  useEffect(function () {
    /* add event listener for escape key press */
    window.addEventListener('keydown', onKeydown, true);

    /* clean up */
    return function () {
      window.removeEventListener('keydown', onKeydown, true);
    };
  });
  var backdrop = /*#__PURE__*/React.createElement(OverlayBackdrop, Object.assign({
    ref: backdropRef,
    onClick: onClick,
    className: addColorSet(staticSet, className),
    $center: center
  }, props, {
    "data-encore-id": ENCORE_DATA_IDS.Backdrop
  }));

  // document.body does not exist in SSR
  return withPortal && isWindowDefined() ? /*#__PURE__*/ReactDOM.createPortal(backdrop, document.body) : backdrop;
});